<template>
  <div class="image-box-tools footer d-flex align-items-center">
    <!-- iPad actions -->
    <template v-if="$attrs.isIPad && $attrs.showEditMenu && $attrs.mode !== 'cropping'">
      <frame-crop-image-box-tool
        ref="FrameCropImageBoxTool"
        custom-classes="submenubutton"
        v-on="$listeners"
      />
      <remove-background-image-box-tool
        v-on="$listeners"
      />
      <bring-to-front-image-box-tool />
      <send-to-back-image-box-tool />
      <text-font-box-tool
        :submenu-value="$attrs.submenu"
        v-on="$listeners"
      />
      <text-size-box-tool
        :last-font-size="$attrs.lastFontSize"
        :submenu-value="$attrs.submenu"
        v-on="$listeners"
      />
      <color-box-tool
        :fill-color="$attrs.fillColor"
        :submenu-value="$attrs.submenu"
        align="none"
        v-on="$listeners"
      />
      <delete-image-box-tool
        :is-editing="$attrs.isEditing"
        v-on="$listeners"
      />
    </template>

    <!-- IPad crop actions -->
    <template v-if="$attrs.isIPad && $attrs.mode === 'cropping'">
      <!-- Sorry Mario the princess is in another castle - Go to 'FrameCropper.vue' -->
      <div style="opacity: 0; height: 48px;">
        &nbsp;
      </div>
    </template>

    <!-- Default actions -->
    <template v-if="!$attrs.isIPad || !$attrs.showEditMenu">
      <!-- Left -->
      <add-image-image-box-tool
        ref="imagetool"
        :add-image-is-open="addImageIsOpen"
        v-on="$listeners"
      />
      <add-text-image-box-tool
        ref="texttool"
        v-on="$listeners"
      />
      <animate-image-image-box-tool v-on="$listeners" />

      <!-- Background tool -->
      <background-color-box-tool
        :fill-color="`#ff0`"
        align="none"
        v-on="bgColorListeners"
      />
    </template>

    <undo-box-tool />
    <redo-box-tool />
  </div>
</template>

<script>
import _ from 'lodash';
import BackgroundColorBoxTool from './BackgroundColorBoxTool';

export default {
  name: 'ImageBoxTools',
  components: { BackgroundColorBoxTool },
  inheritAttrs: false,
  inject: ['parent'],
  props: {
    addImageIsOpen: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      parent: this.parent,
    };
  },
  computed: {
    bgColorListeners() {
      return _.omit(this.$listeners, ['select-color', 'selectColor']);
    },
  },
};
</script>

<style lang="scss">
/**
Menu used on iPad. Important: This is not scoped.
*/
.image-box-tools .submenubutton{
  align-items: center;

  .image-box-tool__icon {
    display: none;
  }

  &:hover{
    width: 100% !important;
    margin-left: 0 !important;
    padding-left: 0.5rem !important;
  }
}
</style>
